import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Input, Modal, Popconfirm, Row, Select, Switch } from 'antd'
import { useNavigate } from 'react-router-dom';

import service from '../../../services/documentRepoService'
import { recordError } from "../../../utils/logService";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export default function RepoLookup(props) {

  const initWidth = 900;

  const [toggleView, setToggleView] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [currentId, setCurrentId] = useState(props.record?.id);
  const [showOrganizationType, setshowOrganizationType] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [modalWidth, setModalWidth] = useState(initWidth);
  const [disableSelection, setDisableSelection] = useState(false);

  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "DocumentRepoLookup";
  let msg = "";

  useEffect(() => {
    toggleModalTitles();
    onFormLoad();

    window.addEventListener('resize', () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 650) {
        setModalWidth(screenWidth * 0.8);
      }
    })
  }, [props.record, window]);

  const toggleModalTitles = () => {
    var _title = props.type?.charAt(0).toUpperCase() + props.type?.slice(1);
    setModalTitle(_title + " Dropdown Option");
  };

  const loadDropdowns  =() => {

  }

  const confirmCancel = () => {
    setshowOrganizationType(false);
    props.onShow(false);
    setDisabled(true);
    form.resetFields();
    setDisableSelection(false)

  };

  const handleCancel = () => {
    if (
      form.getFieldValue("name") ||
      form.getFieldValue("associatedDropdown") ||
      form.getFieldValue("archive")
    ) {
      setDisabled(false);
    } else {
      setshowOrganizationType(false);
      props.onShow(false);
      setDisabled(true);
      setDisableSelection(false)
      form.resetFields();
    }
  };

  const handleDropdownChange = (selected) => {
    if (selected === "Organisation") {
      setshowOrganizationType(true);
    } else {
      setshowOrganizationType(false);
    }
  }

  const confirm = () => {

  };

  const saveValues = (values) => {
    const data = {
      key: values.id,
      active: values.active,
      value: values.name,
      name: values.name,
    }

    let newData = {...data}

    if (showOrganizationType) {
      newData = {...data, organizationTypeId: values.organizationTypeId}
      data.organizationTypeId = values.organizationTypeId;
    }
    
    props.type === "add" ? addDropdownOption(values.dropdown, newData)
      : updateDropdownOption(values.dropdown, newData);
  };

  const addDropdownOption = async (dropdown, data) => {
    data.active = true;
    dropdown.replace("Organisation", "Organization")
    try {
      var response = null;
      switch (dropdown) {
        case "Category":
        case "Document Category":
          response = await service.addDocumentCategory(data);
          break;
        case "Publication Type":
        case "Document Type":
          response = await service.addDocumentType(data);
          break;
        case "Affiliated Organisation":
        case "Affiliated Organization":
        case "Funding Agency":
        default:
          // data.organizationTypeId = props.organisationTypes.find((o) => o.value === dropdown)?.key;
          response = await service.addOganisation(data);
          break;
      }

      if (response && (response.status === 200 || response.status === 201)) {
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Document Dropdown Option");
        openNotification("Document Dropdown Configuration", msg, Notify.SUCCESS);
        confirmCancel();
        props.setHasUpdated(!props.hasUpdated);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Document Dropdown Option");
      openNotification("Document Dropdown Configuration", msg, Notify.ERROR);
    } catch (error) {
      recordError(error);
    }
  };

  const updateDropdownOption = async (dropdown, data) => {
    try {
      var response = null;
      switch (dropdown) {
        case "Category":
        case "Document Category":
          response = await service.updateDocumentCategory(data);
          break;
        case "Document Type":
          response = await service.updateDocumentType(data);
          break;
        case "Affiliated Organisation":
        case "Affiliated Organization":
        case "Funding Agency":
        default:
          data.organizationTypeId = props.organisationTypes.find(o => o.value === dropdown)?.key;
          response = await service.updateOganisation(data);
          break;
      }

      if (response && response.status === 200) {
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Document Dropdown Option");
        openNotification("Document Dropdown Configuration", msg, Notify.SUCCESS);

        confirmCancel();
        props.setHasUpdated(!props.hasUpdated);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Document Dropdown Option");
      openNotification("Document Dropdown Configuration", msg, Notify.ERROR);
    } catch (error) {
      recordError(error);
    }
  };

  const onFormLoad = () => {
    const data = props.record;
    if (!util.isEmpty(data)) {
      
      const selectedOrgType = props.organisationTypes.find(c=>c.value === data.dropdown)
      let selectedOrg="";
      if (selectedOrgType) {
        selectedOrg = props.dropdownLookups.find(c=>c.value === 'Organisation')

        form.setFieldsValue({
          dropdown: selectedOrg.value,});
        setshowOrganizationType(true);
      }
      else {
        form.setFieldsValue({
          dropdown: data.dropdown,});
        setshowOrganizationType(false);
      }

      setDisableSelection(true);
      form.setFieldsValue({
        id: data.id,
        name: data.name,
        // dropdown: selectedOrg.value,
        active: data.active,
        organizationTypeId: selectedOrgType?.key,
      });
    }
  };

  const handleSelectFilter = (input, option) => {
    return (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase());
  }

  return (
    <>
      <Modal
        key="lookup-modal1"
        forceRender
        title={modalTitle}
        open={props.record}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={modalWidth}
        footer={[
          <div className="modal-footer-buttons">
            <Button
              key="bc2"
              type="primary"
              htmlType="submit"
              form={formName}
            >
              Confirm
            </Button>
            <Popconfirm
              key="pc1"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => confirmCancel()}
              onCancel={() => handleCancel()}
              disabled={disabled}
            >
              <Button
                key="blookup1"
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
              >
                Cancel
              </Button>
            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 8,
          }}
          form={form}
          name={formName}
          onFinish={saveValues}
        >
          <Form.Item
            hidden={true}
            name="id"
            label="id"
          >
            <Input name="id" />
          </Form.Item>
          <Form.Item
            name="name"
            label="Dropdown Name"
            rules={[
              {
                required: true,
                message: "Please provide name",
              },
            ]}
          >
            <Input name="name" />
          </Form.Item>
          <Form.Item
            name="dropdown"
            label="Associated Dropdown"
            rules={[
              {
                required: true,
                message: "Please select option",
              },
            ]}
          >
            <Select
              disabled={disableSelection}
              placeholder="Select document dropdown"
              allowClear
              showSearch
              onChange={handleDropdownChange}
              filterOption={handleSelectFilter}
              options={props.dropdownLookups.filter(c=>c.active === true).map((dropdown) => ({
                key: dropdown.value + dropdown.key,
                value: dropdown.key,
                label: dropdown.value,
              }))}
            />
          </Form.Item>
          {showOrganizationType && <Form.Item
            name="organizationTypeId"
            label="Orgaization Type"
            rules={[
              {
                required: true,
                message: "Please select option",
              },
            ]}
          >

            <Select
              disabled={disableSelection}
              placeholder="Select Orgaization type"
              allowClear
              showSearch
              options={props.organisationTypes.map((dropdown) => ({
                key: dropdown.value + dropdown.key,
                value: dropdown.key,
                label: dropdown.value,
              }))}
            />
          </Form.Item>}
          {(props.type !== "add") && (
            <Form.Item
              name="active"
              label="Active"
              valuePropName="checked"
              rules={[
                {
                  required: true,
                  message: "Please provide name",
                },
              ]}
            >
              <Switch checkedChildren="YES" unCheckedChildren="NO" />
            </Form.Item>
          )}
          {/* <Row>
            <Col xs={24} className="center-align">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
              <Popconfirm
                title="Are you sure to cancel ?"
                onConfirm={() => cancel()}
                onCancel={() => confirm()}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="default"
                  htmlType="submit"
                  style={{ marginLeft: 10 }}
                >
                  Cancel
                </Button>
              </Popconfirm>
            </Col>
          </Row> */}
        </Form>
      </Modal>
    </>
  )
}



